import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProvider, Toasts } from './AppContext';
import { StoreLayout } from './StoreLayout';
import { AdminLayout } from './AdminLayout';
import { Directory } from '../pages/Directory';
import { Menu } from '../pages/store/Menu';
import { Hours } from '../pages/store/Hours';
import { About } from '../pages/store/About';
import { Chat } from '../pages/store/Chat';
import { Cart } from '../pages/store/Cart';
import { Orders } from '../pages/store/Orders';
import { Login } from '../pages/store/Login';
import { AdminOrders } from '../pages/admin/AdminOrders';
import { AdminMenu } from '../pages/admin/AdminMenu';
import { AdminSettings } from '../pages/admin/AdminSettings';
import { AdminMedia } from '../pages/admin/AdminMedia';

export function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route path="/" element={<Directory />} />
          <Route path="/:slug/admin" element={<AdminLayout />}>
            <Route index element={<AdminOrders />} />
            <Route path="orders" element={<Navigate to=".." replace />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="*" element={<Navigate to=".." replace />} />
          </Route>
          <Route path="/:slug" element={<StoreLayout />}>
            <Route index element={<Menu />} />
            <Route path="menu" element={<Navigate to=".." replace />} />
            <Route path="hours" element={<Hours />} />
            <Route path="about" element={<About />} />
            <Route path="chat" element={<Chat />} />
            <Route path="cart" element={<Cart />} />
            <Route path="orders" element={<Orders />} />
            <Route path="login" element={<Login />} />
            <Route path="*" element={<Navigate to=".." replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toasts />
      </AppProvider>
    </BrowserRouter>
  );
}
